import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Building2, MapPin, Search } from "lucide-react";

export default function Employers() {
  const [employers, setEmployers] = useState([]);
  const [q, setQ] = useState("");

  const load = async (search = "") => {
    const res = await api.get(`/employers${search ? `?q=${encodeURIComponent(search)}` : ""}`);
    setEmployers(res.data);
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="mb-8">
        <div className="text-xs font-mono-alt uppercase text-yellow-500 tracking-widest mb-2">Directory</div>
        <h1 className="font-display text-5xl md:text-6xl uppercase leading-none">
          <span className="text-yellow-500">{employers.length}</span> Employers hiring
        </h1>
      </div>

      <form onSubmit={(e) => { e.preventDefault(); load(q); }} className="flex items-center border border-zinc-800 focus-within:border-yellow-500 bg-black max-w-xl mb-8">
        <Search size={16} className="text-yellow-500 ml-3" />
        <input
          data-testid="employers-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search employers…"
          className="flex-1 bg-transparent px-3 py-3 text-white placeholder:text-zinc-600 focus:outline-none"
        />
        <button data-testid="employers-search-submit" className="bg-yellow-500 text-black font-bold uppercase tracking-wider px-6 py-3 hover:bg-yellow-400 transition">Go</button>
      </form>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {employers.map((emp, i) => (
          <Link
            key={emp.id}
            to={`/employers/${emp.id}`}
            data-testid={`employer-${emp.id}`}
            className="group border border-zinc-800 hover:border-yellow-500 bg-zinc-950/50 p-6 transition-all"
            style={{ animation: `fadeUp 0.5s ease ${i * 30}ms both` }}
          >
            <Building2 size={20} className="text-yellow-500 mb-3" />
            <div className="font-display text-xl uppercase leading-tight group-hover:text-yellow-500 transition">{emp.name}</div>
            <div className="text-xs text-zinc-500 mt-2 uppercase tracking-wider">{emp.industry}</div>
            <div className="flex items-center justify-between mt-3 text-xs text-zinc-400">
              <span className="flex items-center gap-1"><MapPin size={12} />{emp.location}</span>
              <span className="text-yellow-500 font-mono-alt">{emp.job_count} JOBS</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
